import { render, staticRenderFns } from "./HomeStickyFat.vue?vue&type=template&id=47190ce1&scoped=true"
import script from "./HomeStickyFat.vue?vue&type=script&lang=js"
export * from "./HomeStickyFat.vue?vue&type=script&lang=js"
import style0 from "./HomeStickyFat.vue?vue&type=style&index=0&id=47190ce1&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47190ce1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47190ce1')) {
      api.createRecord('47190ce1', component.options)
    } else {
      api.reload('47190ce1', component.options)
    }
    module.hot.accept("./HomeStickyFat.vue?vue&type=template&id=47190ce1&scoped=true", function () {
      api.rerender('47190ce1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/userCard/HomeStickyFat.vue"
export default component.exports